import drawRadiusRect from "./drawRadiusRect";
/**
 * Draw a filled rectangle defined by `boundingBox` using the style defined by `fillStyle`.
 * @public
 * @method fillBox
 * @memberof Drawing
 *
 * @param {CanvasRenderingContext2D} context - Target context
 * @param {Object} boundingBox - `{ left, top, width, height }` in canvas coordinates.
 * @param {FillStyle} fillStyle - The fillStyle to apply to the region.
 * @returns {undefined}
 */
export default function(
  context,
  boundingBox,
  fillStyle,
  strokeStyle = undefined
) {
  context.fillStyle = fillStyle;

  context.strokeStyle = strokeStyle && strokeStyle;
  drawRadiusRect(
    context,
    boundingBox.left,
    boundingBox.top,
    boundingBox.width,
    boundingBox.height,
    boundingBox.radius,
    true,
    true
  );
  // context.fillRect(
  //   boundingBox.left,
  //   boundingBox.top,
  //   boundingBox.width,
  //   boundingBox.height
  // );
}
